// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QJfsy","open_aside":"Header_open_aside__7roJV"};